import BaseView from '../../../js/base-view';

export default class CountrySwitcher extends BaseView {
	/**
	 * Entrypoint
	 */
	init() {
		this.bindEvents();
	}

	/**
	 * Bind component's events
	 */
	bindEvents() {
		this.on('change', this.onChange.bind(this));
	}

	/**
	 * Redirect to new url
	 *
	 * @param {Event} ev
	 */
	onChange(ev) {
		if (this.el.value !== window.location.href) {
			window.location.assign(this.el.value);
		}
	}
}
